import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ClickAwayListener, MenuList } from '@mui/material';
import { SubMenuProps } from './types';
import { bodyZoomScale } from './common';
import { MenuSurface } from './MenuSurface';

export const SubMenu = ({ open, anchorEl, onClose, children }: SubMenuProps) => {
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const menuRef = useRef<HTMLDivElement>(null);

  const updatePosition = useCallback(() => {
    if (!anchorEl || !open || !menuRef.current) return;

    const anchorRect = anchorEl.getBoundingClientRect();
    const zoomScale = bodyZoomScale();

    setPosition({
      top: anchorRect.top / zoomScale,
      left: anchorRect.right / zoomScale
    });
  }, [anchorEl, open]);

  useEffect(() => {
    const timeoutId = setTimeout(updatePosition, 0);

    window.addEventListener('scroll', updatePosition);
    window.addEventListener('resize', updatePosition);

    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener('scroll', updatePosition);
      window.removeEventListener('resize', updatePosition);
    };
  }, [updatePosition]);

  if (!open) return null;

  return (
    <div
      ref={menuRef}
      style={{
        position: 'fixed',
        top: position.top,
        left: position.left,
        zIndex: 1301
      }}
    >
      <ClickAwayListener onClickAway={onClose}>
        <MenuSurface>
          <MenuList>{children}</MenuList>
        </MenuSurface>
      </ClickAwayListener>
    </div>
  );
};
